// extracted by mini-css-extract-plugin
export var emptyState = "_71-d";
export var statCard = "_71-c";
export var table = "_71-0";
export var tableCell = "_71-4";
export var tableCellClickable = "_71-5 _71-4";
export var tableCellDefault = "_71-6 _71-4";
export var tableCellEmpty = "_71-8";
export var tableCellWithValue = "_71-7";
export var tableContainer = "_71-e";
export var tableHeaderWeight = "_71-1";
export var tableHeaderZone = "_71-2";
export var tableRowHeader = "_71-3";
export var viewModeButton = "_71-9";
export var viewModeButtonActive = "_71-a _71-9";
export var viewModeButtonInactive = "_71-b _71-9";